import request from "../utils/request"

export const saleTarget = (params) => {
  return request.get("/cockpitapi/wechat/CenterScreenData", { params })
}

export const getVideo = (params) => {
  return request.get("/platoperateapi/public/live", { params })
}
